module.exports = __webpack_public_path__ + "static/media/csrd_dashboard.aa322a9f.svg";